<template>
  <table
    class="ui blue very compact celled striped selectable table"
    ref="table"
    style="width: 100%"
    v-show="showing"
  >
    <thead>
      <tr>
        <th>{{ $t("student") }}</th>
        <th>{{ $t("course") }}</th>
        <th>{{ $t("career") }}</th>
        <th>{{ $t("branch") }}</th>
        <th>{{ $t("studying time") }}</th>
      </tr>
    </thead>
    <tbody></tbody>
  </table>
</template>

<script>
import { init_ajax_data_datables } from "@/utils";

export default {
  name: "CourseAssignationStatisticsModalUnassigned",
  data() {
    return {
      datatable: undefined,
      showing: false,
    };
  },
  methods: {
    init(season_id) {
      //   console.log("get season", season_id, "unassigned students");
      let vm = this;
      vm.showing = true;
      let columns = [
        {
          data: function (row) {
            return `${row.std_student.student_id_card} - ${row.std_student.name}`;
          },
        },
        {
          data: function (row) {
            return row.crs_course.name;
          },
        },
        {
          data: function (row) {
            return row.std_career.name;
          },
        },
        {
          data: function (row) {
            return row.std_branch.name;
          },
        },
        {
          data: function (row) {
            return row.std_studying_time.name;
          },
        },
      ];

      let onSelect = (/* data */) => {
        // vm.$refs.transaction_modal.show_modal(data);
      };

      let onCreatedRow = (/* row, data */) => {
        // console.log("row", row);
        // console.log("data", data);
        // if (data.status_code == "X") window.jQuery(row).addClass("negative");
      };

      let transform = (data) => {
        data.search.season_uuid = season_id;
      };

      vm.datatable = init_ajax_data_datables(
        vm,
        vm.$refs.table,
        window.jQuery.fn.api.settings.api["course assignation unassigned url"],
        columns,
        onSelect,
        onCreatedRow,
        transform,
      );
    },
    destroy() {
      if (this.datatable) this.datatable.destroy();
      this.showing = false;
    },
  },
};
</script>
